import GUI from 'lil-gui';

export function createArrowDebugUI(config, callbacks = {}) {
   const gui = new GUI({ title: 'Arrow Animation' });

   // Create folder for animation parameters
   const animationFolder = gui.addFolder('Animation');

   animationFolder
      .add(config, 'distance', 0.5, 10, 0.1)
      .name('Distance')
      .onChange(() => callbacks.onConfigChange?.());

   animationFolder
      .add(config, 'speed', 0.1, 5, 0.1)
      .name('Speed')
      .onChange(() => callbacks.onConfigChange?.());

   animationFolder
      .add(config, 'loopDuration', 0.5, 10, 0.1)
      .name('Loop Duration (s)')
      .onChange(() => callbacks.onConfigChange?.());

   animationFolder.open();

   // Create folder for arrow appearance
   const appearanceFolder = gui.addFolder('Appearance');

   appearanceFolder
      .add(config, 'arrowLength', 0.2, 3, 0.1)
      .name('Arrow Length')
      .onChange(() => callbacks.onConfigChange?.());

   appearanceFolder
      .add(config, 'arrowheadSize', 0.1, 1, 0.05)
      .name('Arrowhead Size')
      .onChange(() => callbacks.onConfigChange?.());

   appearanceFolder
      .add(config, 'strokeWidth', 0.02, 0.5, 0.02)
      .name('Stroke Width')
      .onChange(() => callbacks.onConfigChange?.());

   appearanceFolder
      .addColor({ color: config.arrowColor }, 'color')
      .name('Arrow Color')
      .onChange((value) => {
         config.arrowColor =
            typeof value === 'string'
               ? parseInt(value.replace('#', ''), 16)
               : value;
         callbacks.onConfigChange?.();
      });

   appearanceFolder.open();

   // Create folder for behavior
   const behaviorFolder = gui.addFolder('Behavior');

   behaviorFolder
      .add(config, 'numArrows', 1, 10, 1)
      .name('Arrows per Location')
      .onChange(() => callbacks.onReinitialize?.());

   behaviorFolder
      .add(config, 'enabled')
      .name('Show Arrows')
      .onChange(() => callbacks.onConfigChange?.());

   behaviorFolder.open();

   // Reinitialize button
   gui.add(
      {
         reinitialize: () => {
            console.log('[Arrows] Reinitializing with current config');
            callbacks.onReinitialize?.();
         },
      },
      'reinitialize',
   ).name('Reinitialize Arrows');

   // Copy config button
   gui.add(
      {
         copyConfig: () => {
            const configObj = {
               distance: config.distance,
               speed: config.speed,
               loopDuration: config.loopDuration,
               arrowLength: config.arrowLength,
               arrowheadSize: config.arrowheadSize,
               strokeWidth: config.strokeWidth,
               arrowColor: `#${config.arrowColor.toString(16).padStart(6, '0')}`,
               numArrows: config.numArrows,
               enabled: config.enabled,
            };
            console.log('[Arrows] Current Config:', configObj);
            console.log(JSON.stringify(configObj, null, 2));
         },
      },
      'copyConfig',
   ).name('Log Config');

   return {
      gui,
      destroy() {
         gui.destroy();
      },
   };
}
